import React, { useEffect } from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import * as Cookies from './utils/cookies';
import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';
import { BUILD_DATE_FORMATTED } from './buildDate';


import InvitedToGroup from './layouts/InvitedToGroup/InvitedToGroup';
import Signup from './layouts/Signup/Signup';
import SignIn from './layouts/SignIn/SignIn';
import NewPass from './layouts/NewPass/NewPass';
import NewPassAsk from './layouts/NewPassAsk/NewPassAsk';
import Auth from './partials/Auth';
import Loading from './layouts/Loading/Loading';
import RedirectUser from './layouts/RedirectUser/RedirectUser';
import GroupsList from './layouts/GroupsList/GroupsList';
import LeaguesList from './layouts/LeaguesList/LeaguesList';
import CityLeaguesList from './layouts/CityLeaguesList/CityLeaguesList';
import AddNewGroup from './layouts/AddNewGroup/AddNewGroup';
import EditGroup from './layouts/EditGroup/EditGroup';
import GroupInfo from './layouts/GroupInfo/GroupInfo';
import PlayerProfile from './layouts/PlayerProfile/PlayerProfile';
import PlayerInfo from './layouts/PlayerInfo/PlayerInfo';
import PlayerEdit from './layouts/PlayerEdit/PlayerEdit';
import ProfileEdit from './layouts/ProfileEdit/ProfileEdit';
import UpdateDetails from './layouts/UpdateDetails/UpdateDetails';
import Rounds from './layouts/Rounds/Rounds';
import AddRound from './layouts/AddRound/AddRound';
import EditRoundDate from './layouts/EditRoundDate/EditRoundDate';
import AddMatch from './layouts/AddMatch/AddMatch';
import MatchReport from './layouts/MatchReport/MatchReport';
import MatchEdit from './layouts/MatchEdit/MatchEdit';
import ScoreBoard from './layouts/ScoreBoard/ScoreBoard';
import CheckStates from './partials/CheckStates';
import Term from './layouts/Term/Term';
import LeagueTable from './layouts/LeagueTable/LeagueTable';
import DevTools from './DevTools/DevTools';
import DevToolsFloatingButton from './partials/DevToolsFloatingButton';
import { useDevTools } from './AppContext';
import SignInSMS from './layouts/SignInSMS/SignInSMS';
import Welcome from './layouts/Welcome/Welcome';
import SignupQuick from './layouts/SignupQuick/SignupQuick';
import MustChoosLeague from './partials/MustChooseLeague/MustChoosLeague';
import NotFound from './layouts/NotFound/NotFound';
import { EnvironmentService } from './services/Environment.service';
const lsLeague = 'hachaluts_league'
if (['production', 'staging'].includes(process.env.NODE_ENV)) {
  Sentry.init({
    dsn: 'https://c05c75e959754a3a9594a56da4135725@o530922.ingest.sentry.io/5825091',
    integrations: [new Integrations.BrowserTracing()],




    tracesSampleRate: 0.01,
  });
}
const leagueFromLs = null //localStorage.getItem(lsLeague);
const initialLeagueFromLs =  leagueFromLs? JSON.parse(leagueFromLs) : null;

function App() {
  const devToolsSettings = useDevTools();
  const isQuickSignInEnabled =
    Boolean(devToolsSettings?.devMode) &&
    Boolean(devToolsSettings?.preventRedirect);
  const isQuickSignUpEnabled =
    Boolean(devToolsSettings?.devMode) &&
    Boolean(devToolsSettings?.quickSignUp);

  const [user, setUser] = React.useState(null);
  
  // Restore invited state from sessionStorage on mount
  const [invitedState, setInvitedState] = React.useState(() => {
    try {
      const stored = sessionStorage.getItem('invited');
      return stored ? JSON.parse(stored) : null;
    } catch {
      return null;
    }
  });

  // Wrapper to persist invited state to sessionStorage
  const setInvited = React.useCallback((value) => {
    setInvitedState(value);
    if (value) {
      sessionStorage.setItem('invited', JSON.stringify(value));
    } else {
      sessionStorage.removeItem('invited');
    }
  }, []);

  const invited = invitedState;



  const [league, setLeague] = React.useState( );
  const setLeagueAndPreserve = (league) => {
    localStorage.setItem(lsLeague, JSON.stringify(league));
    setLeague(league);
  }

  const [teams, setTeams] = React.useState([]);

  const [players, setPlayers] = React.useState([]);

  const [rounds, setRounds] = React.useState([]);



  const [matches, setMatches] = React.useState([]);
  const [promoDelay, setPromoDelay] = React.useState(false);

  useEffect(() => {
    setTimeout(() => {
      setPromoDelay(true);
    }, 300);
  }, []);

  const refreshStates = () => {

    setTeams([]);
    setRounds([]);
    Cookies.removeToken();
    sessionStorage.removeItem('otp_temp_token');
    setLeague();
    setUser(null);
  };

   window.__BUILD_DATE__ = BUILD_DATE_FORMATTED;



  return !promoDelay ? (
    <Loading />
  ) : (
    <div className="App">

      {}
      <Router>
        <DevToolsFloatingButton />
        <Switch>
          <Route exact path="/welcome">
            <Welcome />
          </Route>

          <Route exact path="/leagues/:leagueId/teams/:groupId/invite">
            <InvitedToGroup invited={invited} setInvited={setInvited} />
          </Route>
          <Route exact path="/leagues/undefined/profile">
            <MustChoosLeague/>
          </Route>
          <Route exact path="/quick-signup/1">
            <SignupQuick
              user={user}
              setUser={setUser}
              stage={1}
              invited={invited}
            />
          </Route>
          <Route exact path="/signup/1">
            <Signup user={user} setUser={setUser} stage={1} invited={invited} />
          </Route>

          <Route exact path="/signup/term">
            <Term />
          </Route>

          <Route exact path="/signin">
            <SignIn user={user} setUser={setUser} invited={invited} />
          </Route>
          <Route exact path="/signin-sms">
            <SignInSMS user={user} setUser={setUser} invited={invited} />
          </Route>
          <Route path="/newpassask">
            <NewPassAsk user={user} refreshStates={refreshStates} />
          </Route>

          <Route exact path="/reset_password">
            <NewPass />
          </Route>

          <Route exact path="/leagues-score/:leagueId">
            <LeagueTable />
          </Route>

          <Route exact path="/dev-tools">
            <DevTools
              refreshStates={refreshStates}
              quickSignInEnabled={isQuickSignInEnabled}
              quickSignUpEnabled={isQuickSignUpEnabled}
            />
          </Route>

          <Route exact path="/dev-tools/quick-signup">
            {EnvironmentService.isStagingOrDev() ? (
              <SignupQuick
                user={user}
                setUser={setUser}
                stage={1}
                invited={invited}
              />
            ) : (
              <NotFound />
            )}
          </Route>

          <Auth user={user} setUser={setUser}>
            <Route exact path="/redirect">
              <RedirectUser user={user} invited={invited} />
            </Route>

            <Route exact path="/update-details">
              <UpdateDetails user={user} refreshStates={refreshStates} setUser={setUser} />
            </Route>

            <Route exact path="/signup/2">
              <Signup
                user={user}
                setUser={setUser}
                stage={2}
                invited={invited}
              />
            </Route>

            <Route exact path="/signup/3">
              <Signup
                user={user}
                setUser={setUser}
                stage={3}
                invited={invited}
              />
            </Route>

            <Route exact path="/leagues">
              <LeaguesList
                user={user}
                setLeague={setLeagueAndPreserve}
                refreshStates={refreshStates}
              />
            </Route>

            <Route exact path="/leagues/:leagueId/teams/:teamId/join">
              <div className="{style.layoutWithFooterMenu">
                <GroupInfo
                  user={user}
                  setUser={setUser}
                  league={league}
                  setLeague={setLeagueAndPreserve}
                  teams={teams}
                  setTeams={setTeams}
                  players={players}
                  setPlayers={setPlayers}
                  invited={invited}
                  setInvited={setInvited}
                  refreshStates={refreshStates}
                />
              </div>
            </Route>

            <CheckStates league={league} user={user}>
              <Route exact path="/leagues/:leagueId">
                <div className="{style.layoutWithFooterMenu">
                  <GroupsList
                    user={user}
                    league={league}
                    teams={teams}
                    setTeams={setTeams}
                    refreshStates={refreshStates}
                  />
                </div>
              </Route>

              <Route exact path="/leagues/:leagueId/addgroup">
                <div className="{style.layoutWithFooterMenu">
                  <AddNewGroup
                    user={user}
                    league={league}
                    refreshStates={refreshStates}
                  />
                </div>
              </Route>

              <Route exact path="/leagues/:leagueId/teams/:groupId/edit">
                <div className="{style.layoutWithFooterMenu">
                  <EditGroup
                    user={user}
                    league={league}
                    teams={teams}
                    setTeams={setTeams}
                    refreshStates={refreshStates}
                  />
                </div>
              </Route>

              <Route exact path="/leagues/:leagueId/teams/:teamId">
                <div className="{style.layoutWithFooterMenu">
                  <GroupInfo
                    user={user}
                    setUser={setUser}
                    league={league}
                    setLeague={setLeagueAndPreserve}
                    teams={teams}
                    setTeams={setTeams}
                    players={players}
                    setPlayers={setPlayers}
                    invited={invited}
                    setInvited={setInvited}
                    refreshStates={refreshStates}
                  />
                </div>
              </Route>

              <Route exact path="/leagues/:leagueId/profile">
                <PlayerProfile
                  user={user}
                  setUser={setUser}
                  league={league}
                  teams={teams}
                  setTeams={setTeams}
                  refreshStates={refreshStates}
                />
              </Route>

              <Route
                exact
                path="/leagues/:leagueId/teams/:teamId/player/:playerId"
              >
                <PlayerInfo
                  user={user}
                  setUser={setUser}
                  league={league}
                  teams={teams}
                  setTeams={setTeams}
                  players={players}
                  refreshStates={refreshStates}
                />
              </Route>

              <Route exact path="/leagues/:leagueId/profile/edit">
                <ProfileEdit user={user} refreshStates={refreshStates} />
              </Route>

              <Route
                exact
                path="/leagues/:leagueId/teams/:teamId/player/:playerId/edit"
              >
                <PlayerEdit
                  user={user}
                  players={players}
                  setPlayers={setPlayers}
                  refreshStates={refreshStates}
                />
              </Route>

              <Route exact path="/leagues/:leagueId/rounds/:roundId">
                <Rounds
                  user={user}
                  league={league}
                  rounds={rounds}
                  setRounds={setRounds}
                  setMatches={setMatches}
                  refreshStates={refreshStates}
                />
              </Route>

              <Route exact path="/leagues/:leagueId/addround">
                <AddRound
                  user={user}
                  league={league}
                  setRounds={setRounds}
                  refreshStates={refreshStates}
                />
              </Route>

              <Route exact path="/leagues/:leagueId/rounds/:roundId/edit">
                <EditRoundDate
                  user={user}
                  league={league}
                  rounds={rounds}
                  setRounds={setRounds}
                  refreshStates={refreshStates}
                />
              </Route>

              <Route exact path="/leagues/:leagueId/rounds/:roundId/addmatch">
                <AddMatch
                  user={user}
                  league={league}
                  teams={teams}
                  rounds={rounds}
                  refreshStates={refreshStates}
                />
              </Route>

              <Route
                exact
                path="/leagues/:leagueId/rounds/:roundId/matches/:matchId/edit"
              >
                <MatchEdit
                  user={user}
                  league={league}
                  teams={teams}
                  rounds={rounds}
                  matches={matches}
                  refreshStates={refreshStates}
                />
              </Route>

              <Route
                exact
                path="/leagues/:leagueId/rounds/:roundId/matches/:matchId"
              >
                <MatchReport
                  user={user}
                  league={league}
                  matches={matches}
                  setMatches={setMatches}
                  refreshStates={refreshStates}
                />
              </Route>

              <Route exact path="/leagues/:leagueId/scoreboard">
                <ScoreBoard
                  user={user}
                  league={league}
                  refreshStates={refreshStates}
                />
              </Route>
            </CheckStates>

            <Route exact path="/cityleagues/:cityId">
              <CityLeaguesList
                user={user}
                setLeague={setLeagueAndPreserve}
                refreshStates={refreshStates}
              />
            </Route>
          </Auth>

          <Route path={"*"}>
            <NotFound />
          </Route>
        </Switch>
      </Router>
      {}
    </div>
  );
}

export default App;
